import AirtableTable from "../AirtableTable";
import { Course } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class CourseTable extends AirtableTable<Course> {
  	constructor(instance: any) {
		super(instance, airtableTables.courses);

		this.fields = [
			airtableFields.courses.course, airtableFields.courses.subjects, airtableFields.courses.description,
			airtableFields.courses.grade, airtableFields.courses.overview, airtableFields.courses.downloadedBy
		]
	}

	getAll = () => {
		return this.list({
			sort: [{
			  field: airtableFields.courses.course,
			  direction: "asc"
			}]
		})
	}
}
